import environment from 'environment';

import request from 'util/superagent';
import { getSessionToken } from 'util/parseSelectors';

export const submitQualityRating = async (params) => {
  const sessionToken = getSessionToken();
  const response = await request
    .post(`${environment.app.serverApiUrl}/v1/quality-rating/submit-rating`)
    .set('Accept', 'application/json')
    .set('x-session-token', sessionToken)
    .send(params);

  return response.body;
};
